(function () {
  // hashing helper function
  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
  }

  // unique product key retrieve karvanુ function
  function getProductKey(wrapper) {
    const parent = wrapper.closest('[data-product-id]');
    if (parent) {
      const id = parent.getAttribute('data-product-id');
      if (id) return id;
    }
    const form = wrapper.closest('form[action*="/cart/add"]');
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value) {
        return idInput.value;
      }
    }
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.id;
    }
    if (window.meta && window.meta.product) {
      return window.meta.product.id;
    }
    return window.location.pathname;
  }

  function initVisitorWidget(wrapper) {
    if (wrapper.dataset.visitorInitialized === "true") return;
    wrapper.dataset.visitorInitialized = "true";

    const visitorSpan = wrapper.querySelector('.s_vistiter_content span');
    const soldSpan = wrapper.querySelector('.s_unit_sold_out span');

    // 1. Visitors logic: min 12, max 30, updates every 3s (without page reload)
    if (visitorSpan) {
      const updateVisitors = () => {
        const min = 12;
        const max = 30;
        const randomVisitors = Math.floor(Math.random() * (max - min + 1)) + min;
        visitorSpan.textContent = randomVisitors + ' ';
      };
      updateVisitors();
      setInterval(updateVisitors, 3000); // 3000 ms = 3 Seconds
    }

    // 2. Sold out logic: min 26, max 31, unique per product, updates every 24 hours
    if (soldSpan) {
      const productKey = getProductKey(wrapper);
      const today = new Date();
      const dateString = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

      const seed = productKey + '-' + dateString;
      const hash = hashCode(seed);
      const minSold = 26;
      const maxSold = 31;
      const soldUnits = minSold + (hash % (maxSold - minSold + 1));

      soldSpan.textContent = soldUnits + '+';
    }
  }

  // Handle discount copy button on the icon click
  function initDiscountTicket(copyIcon) {
    if (!copyIcon || copyIcon.dataset.copyInitialized === "true") return;
    copyIcon.dataset.copyInitialized = "true";

    copyIcon.addEventListener('click', (e) => {
      e.stopPropagation(); // Avoid parent click behaviors
      
      const card = copyIcon.closest('.m-discount-ticket-card');
      if (!card) return;

      const code = card.getAttribute('data-copy-code');
      if (!code) return;

      navigator.clipboard.writeText(code).then(() => {
        const tooltip = copyIcon.querySelector('.m-copied-tooltip');
        const copySvg = copyIcon.querySelector('.m-copy-svg');
        
        if (tooltip && copySvg) {
          copySvg.style.display = 'none';
          tooltip.style.display = 'inline-block';
          card.classList.add('copied');
          
          setTimeout(() => {
            copySvg.style.display = 'inline-block';
            tooltip.style.display = 'none';
            card.classList.remove('copied');
          }, 2000);
        }
      }).catch(err => {
        console.error('Failed to copy code: ', err);
      });
    });
  }

  // Enable mouse drag-to-scroll with inertia/momentum for buttery smooth desktop drag-scrolling
  function initDragToScroll(slider) {
    if (!slider || slider.dataset.dragInitialized === "true") return;
    slider.dataset.dragInitialized = "true";

    let isDown = false;
    let startX;
    let scrollLeft;
    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let animationId = null;

    const friction = 0.95; // controls speed decay

    function updateInertia() {
      if (!isDown && Math.abs(velocity) > 0.1) {
        slider.scrollLeft -= velocity;
        velocity *= friction;
        animationId = requestAnimationFrame(updateInertia);
      } else {
        velocity = 0;
      }
    }

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      lastX = e.pageX;
      lastTime = Date.now();
      velocity = 0;
      if (animationId) cancelAnimationFrame(animationId);
    });

    slider.addEventListener('mouseleave', () => {
      if (isDown) {
        isDown = false;
        slider.classList.remove('active');
        updateInertia();
      }
    });

    slider.addEventListener('mouseup', () => {
      if (isDown) {
        isDown = false;
        slider.classList.remove('active');
        updateInertia();
      }
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5; // Drag speed multiplier
      slider.scrollLeft = scrollLeft - walk;

      // Track velocity
      const now = Date.now();
      const elapsed = now - lastTime;
      if (elapsed > 0) {
        const deltaX = e.pageX - lastX;
        velocity = (deltaX / elapsed) * 15; // velocity scaling for throw effect
        lastX = e.pageX;
        lastTime = now;
      }
    });
  }

  // Shipping timeline calculation
  function initShippingTimeline(wrapper) {
    if (!wrapper || wrapper.dataset.timelineInitialized === "true") return;
    wrapper.dataset.timelineInitialized = "true";

    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

    function getOrdinalSuffix(day) {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    }

    function formatDate(date) {
      const month = months[date.getMonth()];
      const day = date.getDate();
      const suffix = getOrdinalSuffix(day);
      return `${month} ${day}${suffix}`;
    }

    const now = new Date();

    // 1. Order Date (Always today)
    const orderDate = new Date(now);

    // 2. Shipping Date calculation
    const shippingDate = new Date(now);
    const currentHour = now.getHours();

    // Rule: Order after 2 PM (14:00) ships next day
    if (currentHour >= 14) {
      shippingDate.setDate(shippingDate.getDate() + 1);
    }

    // Rule: Wednesday is leave day, so if shipping date falls on Wednesday, shift it to Thursday
    if (shippingDate.getDay() === 3) {
      shippingDate.setDate(shippingDate.getDate() + 1);
    }

    // 3. Delivery Date range (Shipping + 4 to Shipping + 6 days)
    const deliveryStart = new Date(shippingDate);
    deliveryStart.setDate(deliveryStart.getDate() + 4);

    const deliveryEnd = new Date(shippingDate);
    deliveryEnd.setDate(deliveryEnd.getDate() + 6);

    let deliveryString = "";
    if (deliveryStart.getMonth() === deliveryEnd.getMonth()) {
      deliveryString = `${months[deliveryStart.getMonth()]} ${deliveryStart.getDate()}${getOrdinalSuffix(deliveryStart.getDate())} - ${deliveryEnd.getDate()}${getOrdinalSuffix(deliveryEnd.getDate())}`;
    } else {
      deliveryString = `${formatDate(deliveryStart)} - ${formatDate(deliveryEnd)}`;
    }

    // Write to DOM
    const orderEl = wrapper.querySelector('[data-timeline-order]');
    const shippingEl = wrapper.querySelector('[data-timeline-shipping]');
    const deliveryEl = wrapper.querySelector('[data-timeline-delivery]');

    if (orderEl) orderEl.textContent = formatDate(orderDate);
    if (shippingEl) shippingEl.textContent = formatDate(shippingDate);
    if (deliveryEl) deliveryEl.textContent = deliveryString;
  }

  function scanAndInit() {
    document.querySelectorAll('.m_visiter_wapper').forEach(initVisitorWidget);
    document.querySelectorAll('.m-discount-ticket-card__copy-icon').forEach(initDiscountTicket);
    document.querySelectorAll('.m-discount-tickets-scroll').forEach(initDragToScroll);
    document.querySelectorAll('[data-shipping-timeline]').forEach(initShippingTimeline);
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInit);
  } else {
    scanAndInit();
  }

  // Observer to handle dynamically loaded content (e.g. Quick View modals)
  const observer = new MutationObserver((mutations) => {
    let shouldScan = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) { // Element node
          if (
            node.classList.contains('m_visiter_wapper') || 
            node.querySelector('.m_visiter_wapper') ||
            node.classList.contains('m-discount-ticket-card__copy-icon') ||
            node.querySelector('.m-discount-ticket-card__copy-icon') ||
            node.classList.contains('m-discount-tickets-scroll') ||
            node.querySelector('.m-discount-tickets-scroll') ||
            node.classList.contains('m-shipping-timeline-wrapper') ||
            node.querySelector('[data-shipping-timeline]')
          ) {
            shouldScan = true;
            break;
          }
        }
      }
      if (shouldScan) break;
    }
    if (shouldScan) {
      scanAndInit();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
